const content = `
# Results

The Results section displays simulation output across four visualization types plus summary metric pills.

## Energy Flow Chart

A **time-series area chart** showing power (kW) over the simulation duration. Stacked areas represent:

- **Solar Generation** (gold) — PV output following the Gaussian solar curve
- **Grid Import** (blue) — Power drawn from the grid when local generation is insufficient
- **BESS Discharge** (purple) — Battery energy delivered to loads
- **EV Charging** (teal) — Total EV charger demand
- **System Losses** (red) — Cumulative conversion losses across all components

Hover over the chart to see exact values at any minute. The chart clearly shows how solar generation offsets grid imports during daylight hours.

## Single-Line Diagram

An **animated power flow schematic** showing real-time energy routing through the topology. Nodes represent equipment (PV, BESS, Grid, Chargers, Load) and animated flow lines show power direction and magnitude.

Key features:
- Line thickness scales with power magnitude
- Flow animation direction shows power direction (generation vs consumption)
- Node pulse effects indicate active power transfer
- Color-coded by source: gold for solar, blue for grid, purple for BESS

## Sankey Diagram

An **energy allocation diagram** showing where each unit of energy goes from source to sink. Useful for seeing at a glance how much PV energy reaches the EV vs. how much is lost in conversions.

Band widths are proportional to energy (kWh). The narrowing between source and destination bands represents conversion losses.

## Metric Pills

Summary statistics displayed as compact pill badges below the chart:

| Metric | Unit | Description |
|--------|------|-------------|
| **System Efficiency** | % | Ratio of useful energy delivered to total energy input |
| **Total Energy** | kWh | Total energy processed through the system |
| **Peak Demand** | kW | Maximum instantaneous grid import |
| **Solar Fraction** | % | Portion of load served by PV generation |
| **Total Losses** | kWh | Energy lost to conversions across all components |

## Methodology Tooltips

Click the **info icon** on any chart element to see the methodology used. Each tooltip explains the formula, model assumptions, and caveats. For example, solar generation uses \`P(t) = Pmax * exp(-(t-12)^2 / 18)\` and inverter efficiency follows the Sandia CEC model varying from ~89% at 10% load to ~96% at full load.

## Simulation History

The sidebar shows a list of previous simulation runs. Click any history entry to reload its results without re-running the simulation.
`;

export default content;
